import { YStack } from "tamagui";
import { jsx } from "react/jsx-runtime";
const KeyBoardAvoidView = ({
  children,
  props
}) => {
  return /* @__PURE__ */jsx(YStack, {
    ...props,
    children
  });
};
export { KeyBoardAvoidView };
//# sourceMappingURL=KeyBoardAvoidView.mjs.map
